import React from "react";
import styled from "styled-components";
import GaugeChart from "./GaugeChart";

const Item = styled.div`
  width: 130px;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: flex-end;

  h2 {
    margin-bottom: 20px;
    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }
`;

const Usage = ({ opt, flows, groups, subscribers }) => {
  const optValues = opt? opt.split(/\s+/): [];
  return (
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div className="card">
        <div className="body tcp-optimization-and-flow">
          <div className="kpi-container">
            <div className="kpi-item">
              <GaugeChart
                width="80"
                height="80"
                viewLink="viewStatusTCPO"
                title="TCP Optimized"
                value={Number(optValues[0])}
              />
            </div>
            <Item onClick={() => globalNavigate("viewStatusSubscribers")}>
              <h2>{subscribers}</h2>
              <div>Subscribers</div>
            </Item>
            <Item onClick={() => globalNavigate("viewStatusSubscriberGroups")}>
              <h2>{groups}</h2>Groups
            </Item>
            <Item onClick={() => globalNavigate("viewFlowsPerSubs")}>
              <h2>{flows}</h2>
              <div>Flows</div>
            </Item>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Usage;
